// 接口基础域名 —— 由环境变量决定，不要在这里写死：
//   npm run serve / dev  → .env.development（测试）
//   npm run build        → .env.production（正式）
// 本地想连别的后端，新建 .env.local 覆盖即可（该文件已被 gitignore）：
//   VUE_APP_API_BASE_URL=http://192.168.0.108:8010
//
// 兜底值取正式域名：万一 .env.production 缺失，打出来的包也不会误连测试环境。
export const API_BASE_URL = (process.env.VUE_APP_API_BASE_URL || "https://mu8888.cc").replace(/\/+$/, "");
